import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/support/store/requestSlice/initialState.ts'
import { RequestType } from '@/modules/support/types/RequestType.ts'
import { RequestViewMode } from '@/modules/support/types/RequestViewMode.ts'

const requestSlice = createSlice({
  name: 'request',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    setViewMode: (state, action: PayloadAction<RequestViewMode>) => {
      state.viewMode = action.payload
    },
    setRequestType: (state, action: PayloadAction<RequestType>) => {
      state.requestType = action.payload
    },
    reset: () => initialState
  }
})

export const requestActions = requestSlice.actions
export const { reducer: requestReducer } = requestSlice
